import React, { useState, useEffect } from 'react';

const JobSeekerStats = () => {
  const [stats, setStats] = useState({
    artisan: 0,
    professional: 0,
    student: 0,
    jobSeeker: 0,
    jobChanger: 0,
    unemployed: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobSeekers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`);
        const data = await response.json();
        console.log(data, "your job stats")
        if (Array.isArray(data)) {
          const jobModeCounts = data.reduce(
            (acc, seeker) => {
              const mode = seeker?.jobMode?.toLowerCase();
              if (mode === 'artisan') acc.artisan++;
              if (mode === 'professional') acc.professional++;
              if (mode === 'student') acc.student++;
              return acc;
            },
            { artisan: 0, professional: 0, student: 0 }
          );

          const jobDecisionCounts = data.reduce(
            (acc, seeker) => {
              const decision = seeker?.jobDecision?.toLowerCase();
              if (decision === 'job-seeker') acc.jobSeeker++;
              if (decision === 'job-changer') acc.jobChanger++;
              return acc;
            },
            { jobSeeker: 0, jobChanger: 0 }
          );

          const unemployedCount = data?.filter(seeker => {
            return (seeker.jobDecision?.toLowerCase() === 'job-seeker' || seeker.jobDecision?.toLowerCase() === 'job-changer') &&
                   (!seeker.appliedJobs || seeker.appliedJobs.length === 0);
          }).length;

          setStats({
            ...jobModeCounts,
            ...jobDecisionCounts,
            unemployed: unemployedCount,
          });
        }
      } catch (error) {
        console.error("Error fetching job seekers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  if (loading) return <div className="text-center py-4">Loading...</div>;

  return (
    <div className="bg-white p-4 sm:p-6">
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-900">Job Seeker Statistics</h1>
      <ul className="flex flex-wrap justify-center gap-2 sm:gap-8">
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Artisans</h3>
          <p className="text-sm text-gray-600">{stats.artisan}</p>
        </li>
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Professionals</h3>
          <p className="text-sm text-gray-600">{stats.professional}</p>
        </li>
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Students</h3>
          <p className="text-sm text-gray-600">{stats.student}</p>
        </li>
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Job Seekers</h3>
          <p className="text-sm text-gray-600">{stats.jobSeeker}</p>
        </li>
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Job Changers</h3>
          <p className="text-sm text-gray-600">{stats.jobChanger}</p>
        </li>
        <li className="px-3 py-2 border-2 w-40 sm:w-[200px] bg-gray-50 text-center">
          <h3 className="text-lg font-medium text-gray-800">Unemployed</h3>
          <p className="text-sm text-gray-600">{stats.unemployed}</p>
        </li>
      </ul>
    </div>
  );
};

export default JobSeekerStats;